module.exports = __webpack_public_path__ + "img/nt_police_logo.2761a2ce.png";